//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import socialShareBtns from "~/components/social-share-btns";
import { KinesisContainer, KinesisElement } from "vue-kinesis";
import BannerType1 from "~/components/content-elements/banner-type-1";
export default {
  components: {
    BannerType1,
    KinesisElement,
    socialShareBtns,
    KinesisContainer,
  },
  data() {
    return {
      currentalbum: 0,
    };
  },
  async asyncData({ store, route }) {
    await store.dispatch("tea-inspired/getTeaInspiredImages");
    const pageData = store.state["tea-inspired"].teainspiredimages[0].page;
    const estateInfo = pageData.photographers.find(
      (item) => item.id == route.params.id
    );

    return { pageData, estateInfo };
  },
  head() {
    return {
      title: this.estateInfo.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.estateInfo.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.estateInfo.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.estateInfo.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.estateInfo.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.estateInfo.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.estateInfo.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.estateInfo.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.estateInfo.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.estateInfo.seo.prevent_indexing,
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("tea-inspired/getTeaInspiredImages");
  },
  computed: {
    nextalbum() {
      if (this.pageData.photographers.length - 1 == this.currentalbum) {
        let data = this.pageData.photographers[0];
        data.slideIndex = 0;
        return data;
      } else {
        let data = this.pageData.photographers[this.currentalbum + 1];
        data.slideIndex = this.currentalbum + 1;
        return data;
      }
    },
    previousalbum() {
      if (this.currentalbum > 0) {
        let data = this.pageData.photographers[this.currentalbum - 1];
        data.slideIndex = this.currentalbum - 1;
        return data;
      } else {
        let data =
          this.pageData.photographers[this.pageData.photographers.length - 1];
        data.slideIndex = this.pageData.photographers.length - 1;
        return data;
      }
    },
  },
};
